import './Icon.scss';

import { Icon as MaterialIcon } from '@mdi/react';
import React from 'react';

interface Props extends Pick<
  React.HTMLAttributes<HTMLDivElement>,
  'role' | 'tabIndex' | 'onKeyDown' | 'aria-labelledby' | 'aria-expanded' | 'aria-controls'
> {
  path: string;
  size?: number | string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  viewBox?: string;
  fill?: string;
}

const defaultViewBox = '0 0 24 24';

const Icon: React.FC<Props> = (props): React.ReactElement => {
  if (props.onClick) {
    return (
      <div
        className="IconWrapper"
        onClick={props.onClick}
        role={props.role}
        tabIndex={props.tabIndex}
        onKeyDown={props.onKeyDown}
        aria-labelledby={props['aria-labelledby']}
        aria-expanded={props['aria-expanded']}
        aria-controls={props['aria-controls']}
      >
        <MaterialIcon
          className={`Icon ${props.className || ''}`}
          path={props.path}
          size={props.size}
          // TODO: viewBox props not working as additional package props, maybe it will be resolved in future
          // @ts-ignore
          viewBox={props.viewBox || defaultViewBox}
          color={props.fill}
        />
      </div>
    );
  }

  return (
    <MaterialIcon
      className={`Icon ${props.className || ''}`}
      path={props.path}
      size={props.size}
      // TODO: viewBox props not working as additional package props, maybe it will be resolved in future
      // @ts-ignore
      viewBox={props.viewBox || defaultViewBox}
      color={props.fill}
    />
  );
};

export default Icon;
